import React, { useCallback, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { fetchRmBuddiesWarehouseList } from "../../../redux/rm-buddies/actions";
import { useHistory } from "react-router-dom";

function WarehouseSelector() {
  const currentWarehouseId = useSelector(
    ({ rmBuddies }) => rmBuddies.currentWarehouseId
  );
  const warehouseList = useSelector(
    ({ rmBuddies }) => rmBuddies.warehouseList,
    shallowEqual
  );
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    if (!warehouseList) {
      dispatch(fetchRmBuddiesWarehouseList());
    }
  }, [warehouseList, dispatch]);
  const changeCurrentWarehouseId = useCallback(
    (e, { value }) => {
      if (value !== "CHOOSE") {
        history.push(`/rmBuddies/${value}/`);
      }
    },
    [history]
  );
  const options = warehouseList
    ? warehouseList.map((e, i) => ({ key: i, value: e.id, text: e.name }))
    : [];
  return (
    <div className="WarehouseSelector">
      {warehouseList ? (
        <Dropdown
          search
          selection
          options={[
            { key: 1000, value: "CHOOSE", text: "Choose a Warehouse" },
            ...options
          ]}
          value={currentWarehouseId ? currentWarehouseId : "CHOOSE"}
          onChange={changeCurrentWarehouseId}
        />
      ) : (
        <Dropdown
          selection
          options={[{ key: -1, value: "loading...", text: "Loading" }]}
          value={"loading..."}
        />
      )}
    </div>
  );
}

export default WarehouseSelector;
